import { render } from "./MusicPlayer.vue?vue&type=template&id=2f2d22f9&scoped=true"
import script from "./MusicPlayer.vue?vue&type=script&lang=js"
export * from "./MusicPlayer.vue?vue&type=script&lang=js"

import "./MusicPlayer.vue?vue&type=style&index=0&id=2f2d22f9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2d22f9"]])

export default __exports__